import React from 'react';

const Copyright = () => (
  <div className="copyright-franch">
    © 2021 TROCAFONE - Comercialização de Aparelhos Eletrônicos LTDA. Todos os direitos reservados.
  </div>
);

export default Copyright;
